export default Object.freeze({
  Environment: 1,
});
